export const textCapitalize = (text: string) => text.replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase());
